// === Libs ===
import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import clsx from 'clsx';

// === Style ===
import classes from './poll-card.module.scss';
import cardClasses from '@/common/components/core/card/card.module.scss';

// === Types ===
import { PollCardTypes } from './poll-card.types';

// === Components ===
import Card from '@/common/components/core/card/card';
import CardHeader from '@/common/components/core/card/card-header/card-header';
import CardBody from '@/common/components/core/card/card-body/card-body';
import CardFooter from '@/common/components/core/card/card-footer/card-footer';
import { formatPollStatus, formatReportStatus } from '@/helpers/formatStatus';

const PollCard: FC<
  PollCardTypes.PollCardModel & { className?: string; orgId?: number }
> = (props) => {
  const {
    id = '',
    title = '',
    status = '',
    mode = 'executor',
    availablePeriod = {
      start: '',
      end: '',
    },
    className = '',
    orgId,
  } = props;

  const status_repr =
    mode === 'author' ? formatPollStatus(status) : formatReportStatus(status);

  return (
    <Card className={clsx({ [classes.card]: true }, className)}>
      <CardHeader label={status_repr.text} labelColor={status_repr.color} />
      <CardBody>
        <Link
          to={
            mode === 'executor'
              ? `/poll/${mode}/${orgId || 'public'}/${id}/`
              : `/poll/${mode}/${id}/`
          }
          className={clsx({
            [cardClasses.card__title]: true,
            [classes.card__title]: true,
          })}>
          <h3>{title}</h3>
        </Link>
      </CardBody>
      <CardFooter
        infoList={[
          {
            type: 'timer',
            title: `${availablePeriod.start} - ${availablePeriod.end}`,
            color: 'primary',
          },
        ]}
      />
    </Card>
  );
};

export { PollCard };
